<template>
  <div v-loading="loading">
    <pt-page-title :title="`${title}生产任务`">
    </pt-page-title>
    <pt-production-task-form :value="currentForm" :isEdit="isEdit" ref="form" class="pt-production-task-form__withData" :bill="bill"></pt-production-task-form>
    <div class="button-div">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button> <el-button type="danger" plain @click="closeTask" v-if="!isClosed || !isComplete">关闭任务单</el-button>
        <el-button type="danger" plain @click="deleteTask" >删除任务单</el-button>
    </div>
  </div>
  
</template>

<script>
import PtProductionTaskForm from './index'
export default {
  name: 'pt-production-task-form__withData',
  components: {
    'pt-production-task-form': PtProductionTaskForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }, 
    title () {
      return this.isEdit ? '编辑' : '创建'
    },
    isComplete () {
      return this.currentForm && this.currentForm.nextOrderAction === 'NONE'
    },
    isClosed () {
      return this.currentForm && this.currentForm.status === 'PRODUCTION_TASK_CLOSE'
    },
  },
  data () {
    return {
      loading: false,
      currentForm: null,
      bill:null
    }
  },
  methods: {
    handleClose(){
      this.loading = true
      this.$store.dispatch('closeTask', this.currentForm.id).then((response) => {
          
        this.$message.success('关闭任务单成功！')
        this.$router.push('/production-task-list')
      }).catch((error) => {
        this.$message.error(error + '关闭任务单失败！')
      }).finally(()=>{
        this.loading = false
      })
    },
    closeTask(){
      this.$confirm(`该操作将关闭所有样品，如不需关闭下属样品，请提前进行分配`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(!this.isComplete && this.currentForm.status !=='NO_ORDER'){
            this.$confirm(`您要关闭的样品中包含尚未完成检测的样品，请确认是否关闭，关闭将不可恢复。如需继续操作该样品，请对该样品进行重新分配。点击确定将继续关闭尚未完成的样品。`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleClose()
          })
        }else{
          this.handleClose()
        }
      })
    },
    deleteTask(){
      this.loading = true
      this.$store.dispatch('deleteTask', this.currentForm.id).then((response) => {
          
          this.$message.success('关闭任务单成功！')
          this.$router.go(-1)
        }).catch((error) => {
          this.$message.error(error + '关闭任务单失败！')
        }).finally(()=>{
          this.loading = false
        })
    },
    load (id) {
      this.loading = true
      this.$store.dispatch('getProductionTasksDetail', id).then((data) => {
        console.log('====d',data)
        this.loadFailed = false
        this.loading = false
        this.currentForm = data.productionTask
        this.bill = data.bill
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        console.error(error)
        this.$message.error(error || '获取任务单信息失败！')
      })
    },
    
    save () {
      this.form.formValidata().then(form => {
        this.loading = true
        let copyData = JSON.parse(JSON.stringify(form))
        !this.isEdit || this.recollect ? this.create(this.change(copyData)) : this.edit(copyData)
      })
    },
    cancel () {
      history.go(-1)
    },
    edit (formValue) {
      
      this.$store.dispatch('updateTask', formValue).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
  },
  created () {
    if (this.isEdit) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
